<div class="modal-dialog modal-dialog-scrollable m-0 scrollable-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">PWA Details - {{ data.username }}</h5>
      <span class="modal-x-button" (click)="onCloseDialog()">
        <i class="fa fa-times" aria-hidden="true"></i>
      </span>
    </div>
    <div class="modal-body">

      <!-- Member -->
      <div class="row mb-4" *ngIf="member">
        <div class="col-md-3"><b>Username:</b> {{ member.username }}</div>
        <div class="col-md-3"><b>Name:</b> {{ member.name ? member.name : '-' }}</div>
        <div class="col-md-3"><b>Phone:</b> {{ member.mobile ? member.mobile : '-' }}</div>
        <div class="col-md-3"><b>Currency:</b> {{ member.currency ? member.currency : '-' }}</div>
      </div>

      <!-- Devices -->
      <h6 class="mb-2">Devices</h6>
      <p class="text-muted small mb-2">
        Only sessions launched from the installed app are recorded - ordinary browser visits never
        appear here. A device is identified by the app's own storage, so a reinstall, a move to a
        new domain, or clearing site data starts a new row for the same person. Treat the count as
        an upper bound. First Launch is kept for good. Launches is counted from the 90-day activity
        log when the device last reported, so a device that has stopped using the app can still
        show older launches until its last log ages out and the count drops to 0.
      </p>
      <div class="table-responsive mb-4">
        <table class="table table-bordered table-hover table-striped">
          <thead>
            <tr>
              <th class="text-center">Platform</th>
              <th class="text-center">Device</th>
              <th>Domain</th>
              <th class="text-center">Launches</th>
              <th class="date-column">First Launch</th>
              <th class="date-column">Last Active</th>
              <th class="date-column">Last Login</th>
              <th>Visitor ID</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of devices">
              <td class="text-center">{{ row.platform ? row.platform : '-' }}</td>
              <td class="text-center">{{ row.device_type ? row.device_type : '-' }}</td>
              <td>{{ row.domain ? row.domain : '-' }}</td>
              <td class="text-center">{{ row.launch_count }}</td>
              <td>{{ row.first_launch_at ? (row.first_launch_at | timezoneDate: 'YYYY-MM-DD HH:mm:ss') : '-' }}</td>
              <td>{{ row.last_active_at ? (row.last_active_at | timezoneDate: 'YYYY-MM-DD HH:mm:ss') : '-' }}</td>
              <td>{{ row.last_login_at ? (row.last_login_at | timezoneDate: 'YYYY-MM-DD HH:mm:ss') : '-' }}</td>
              <td><small>{{ row.visitor_id }}</small></td>
            </tr>
            <kt-fallback-row *ngIf="!loading" [collection]="devices"></kt-fallback-row>
          </tbody>
        </table>
      </div>

      <!-- Activity -->
      <h6 class="mb-2">Activity</h6>
      <p class="text-muted small mb-2">
        <b>launch</b> = cold start of the installed app &middot;
        <b>resume</b> = brought back from the background &middot;
        <b>login</b> = authenticated session started &middot;
        <b>logout</b> = pressed log out. Rows recorded before the member logged in are included.
      </p>
      <p class="text-muted small mb-2">
        The app records one <b>login</b> per app session, whether the member typed their password or
        a stored token was restored on boot, and one more if someone else logs in on the same device.
        So a member who stays signed in shows far fewer logins than launches — that is the app not
        repeating itself, not a missing row.
      </p>
      <div class="table-responsive">
        <table class="table table-bordered table-hover table-striped">
          <thead>
            <tr>
              <th class="date-column">Date/Time</th>
              <th class="text-center">Action</th>
              <th class="text-center">Platform</th>
              <th>Domain</th>
              <th>IP</th>
              <th>Visitor ID</th>
              <th>Session ID</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of activities">
              <td>{{ row.created_at | timezoneDate: 'YYYY-MM-DD HH:mm:ss' }}</td>
              <td class="text-center">{{ row.action }}</td>
              <td class="text-center">{{ row.platform ? row.platform : '-' }}</td>
              <td>{{ row.domain ? row.domain : '-' }}</td>
              <td>{{ row.ip ? row.ip : '-' }}</td>
              <td><small>{{ row.visitor_id }}</small></td>
              <td><small>{{ row.session_id ? row.session_id : '-' }}</small></td>
            </tr>
            <kt-fallback-row *ngIf="!loading" [collection]="activities"></kt-fallback-row>
          </tbody>
        </table>
      </div>

      <div class="kt-pagination kt-pagination--brand mt-2" *ngIf="pagination !== undefined">
        <ngb-pagination [pageSize]="pageSize" [(page)]="page" [maxSize]="maxSize"
          [directionLinks]="true" [boundaryLinks]="true" [rotate]="true"
          [collectionSize]="pagination.total" (pageChange)="load(page)">
        </ngb-pagination>
        <div class="kt-pagination__toolbar">
          <span class="pagination__desc">
            Showing {{pagination.from}} to {{pagination.to}} of
            {{ pagination.total | number : '1.0' }} records
          </span>
        </div>
      </div>

    </div>
  </div>
</div>
